var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlineai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3 17.5C2 17.5 0 15.5 0 11.2C0 11.2 0 6.3 0 6.3C0 1.9 2 0 6.4 0C6.4 0 8 0 8 0C8.4 0 8.8 0.3 8.8 0.8C8.8 1.2 8.5 1.6 8 1.6C8 1.6 6.4 1.6 6.4 1.6C2.8 1.6 1.5 2.9 1.5 6.4C1.5 6.4 1.5 11.3 1.5 11.3C1.5 14.9 2.8 16.1 6.3 16.1C6.3 16.1 11.2 16.1 11.2 16.1C14.8 16.1 16.1 14.8 16.1 11.3C16.1 11.3 16.1 11.3 16.1 11.3C16.1 11.3 16.1 9.5 16.1 9.5C16.1 9.1 16.4 8.7 16.9 8.7C17.3 8.7 17.7 9 17.7 9.5C17.7 9.5 17.7 11.2 17.7 11.2C17.7 11.2 17.7 11.2 17.7 11.2C17.7 15.6 15.7 17.5 11.3 17.5C11.3 17.5 6.3 17.5 6.3 17.5C6.3 17.5 6.3 17.5 6.3 17.5Z",
    transform: "translate(2 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 7.7C0.400001 7.7 0 7.4 0 6.9C0 1.4 4.5 0 6.9 0C7.3 0 7.7 0.3 7.7 0.8C7.7 1.2 7.4 1.5 7 1.6C7 1.6 7 1.6 7 1.6C6.8 1.6 1.6 1.7 1.6 7C1.5 7.4 1.2 7.7 0.8 7.7C0.8 7.7 0.8 7.7 0.8 7.7Z",
    transform: "translate(14.3 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 7.7C1.4 7.7 0 3.2 0 0.8C0 0.4 0.3 0 0.8 0C1.2 0 1.5 0.3 1.6 0.7C1.6 0.7 1.6 0.7 1.6 0.7C1.6 0.9 1.7 6.1 7 6.1C7.4 6.1 7.8 6.4 7.8 6.9C7.8 7.4 7.4 7.7 6.9 7.7C6.9 7.7 6.9 7.7 6.9 7.7Z",
    transform: "translate(14.3 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 7.8C0.400001 7.8 0 7.5 0 7C0 6.6 0.3 6.3 0.7 6.2C0.7 6.2 0.7 6.2 0.7 6.2C0.9 6.2 6.1 6.1 6.1 0.8C6.1 0.4 6.4 0 6.9 0C7.4 0 7.7 0.3 7.7 0.8C7.7 6.3 3.2 7.8 0.8 7.8C0.8 7.8 0.8 7.8 0.8 7.8Z",
    transform: "translate(8.1 1.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.7C6.6 7.7 6.3 7.4 6.2 7C6.2 7 6.2 7 6.2 7C6.2 6.8 6.1 1.6 0.8 1.6C0.400001 1.6 0 1.3 0 0.8C0 0.3 0.3 0 0.8 0C6.3 0 7.7 4.5 7.7 6.9C7.7 7.4 7.4 7.7 7 7.7C7 7.7 7 7.7 7 7.7Z",
    transform: "translate(8.1 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 4.7C0.400001 4.7 0 4.4 0 3.9C0 0.799999 2.5 0 3.9 0C4.3 0 4.7 0.3 4.7 0.8C4.7 1.2 4.4 1.5 4 1.6C3.6 1.6 1.6 1.7 1.6 4C1.6 4.4 1.2 4.7 0.8 4.7C0.8 4.7 0.8 4.7 0.8 4.7Z",
    transform: "translate(8.1 14.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 4.7C0.799999 4.7 0 2.2 0 0.8C0 0.400001 0.3 0 0.8 0C1.2 0 1.5 0.3 1.6 0.7C1.6 1.1 1.7 3.1 4 3.1C4.4 3.1 4.8 3.4 4.8 3.9C4.8 4.4 4.3 4.7 3.9 4.7C3.9 4.7 3.9 4.7 3.9 4.7Z",
    transform: "translate(8.1 11.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 4.8C0.4 4.8 0 4.5 0 4C0 3.6 0.3 3.3 0.7 3.2C1.1 3.2 3.1 3.1 3.1 0.8C3.1 0.400001 3.4 0 3.9 0C4.4 0 4.7 0.3 4.7 0.8C4.7 4 2.1 4.8 0.8 4.8C0.8 4.8 0.8 4.8 0.8 4.8Z",
    transform: "translate(5 11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.7C3.6 4.7 3.3 4.4 3.2 4C3.2 3.6 3.1 1.6 0.8 1.6C0.4 1.6 0 1.3 0 0.8C0 0.3 0.3 0 0.8 0C3.9 0 4.7 2.5 4.7 3.9C4.8 4.4 4.4 4.7 4 4.7C4 4.7 4 4.7 4 4.7Z",
    transform: "translate(4.9 14.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineai);
export default __webpack_public_path__ + "static/media/vuesaxoutlineai.286146c3388b3bd5bceb163d8aa01dc0.svg";
export { ForwardRef as ReactComponent };